import React from "react";
import { motion } from "framer-motion";
import { FaChartLine, FaCode, FaCogs, FaSearch } from "react-icons/fa";

const steps = [
    {
        id: "discover",
        title: "Discover",
        description:
            "We understand your business goals, challenges, and growth opportunities.",
        icon: <FaSearch />,
    },
    {
        id: "build",
        title: "Build",
        description:
            "We create websites, applications, and software solutions tailored to your needs.",
        icon: <FaCode />,
    },
    {
        id: "automate",
        title: "Automate",
        description:
            "We streamline operations using CRM systems, WhatsApp solutions, and business automation tools.",
        icon: <FaCogs />,
    },
    {
        id: "scale",
        title: "Scale",
        description:
            "We help businesses attract customers, improve engagement, and accelerate growth.",
        icon: <FaChartLine />,
    },
];

export const GrowthProcessSection = () => (
    <section className="premium-section growth-process">
        <div className="premium-section-inner">
            <div className="growth-process__header">
                <h3>How We Help Businesses Grow</h3>
                <p className="growth-process__subtitle">
                    A simple process that transforms ideas into measurable business growth.
                </p>
            </div>

            <div className="growth-process__track" aria-label="Discover, Build, Automate, Scale">
                {steps.map((step, index) => (
                    <React.Fragment key={step.id}>
                        <motion.div
                            className="growth-process__step"
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.45, delay: index * 0.08 }}
                        >
                            <span className="growth-process__step-icon">{step.icon}</span>
                            <div className="growth-process__step-body">
                                <h4 className="growth-process__step-title">{step.title}</h4>
                                <p className="growth-process__step-desc">{step.description}</p>
                            </div>
                        </motion.div>
                        {index < steps.length - 1 && (
                            <div className="growth-process__connector" aria-hidden="true" />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    </section>
);
